import getPropFromModule from './getPropFromModule';

const getProductsCartRequireValidate = state =>
  getPropFromModule(state, 'productsRequireValidate');

export default getProductsCartRequireValidate;
